import React from "react";
import { useBreakpoints } from "../../../hooks/useBreakpoints";

const ResponsiveView = ({
  mobile,
  tablet,
  desktop,
  largeDesktop,
  fallback = null,
}) => {
  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useBreakpoints();

  if (isMobile && mobile) return mobile;
  if (isTablet && tablet) return tablet;
  if (isLargeDesktop && largeDesktop) return largeDesktop;
  if (isDesktop && desktop) return desktop;

  return fallback;
};

export default ResponsiveView;
